export const CASE_ITEMS_PER_PAGE = 25;

export class CaseSearchInput{
    page?: number;
    limit?: number;
    sortCriteria?: string;
    pillars?: string[];
    documentType?: string;
    authorities?: string[];
    companies?: string[];
    commercialNames?: string[];
    subThemes?: string[];
    fromDecisionDate?: string;
    toDecisionDate?: string;
    countries?: string[];
    aims?: string[];
    targets?: string[];
    outcomes?: string[];
    themes?: string[];
    types?: string[];
    showOpenCases?:boolean;
    
    constructor(params: CaseSearchInput = {} as CaseSearchInput) {

        const {
            page = 0,
            limit = CASE_ITEMS_PER_PAGE,
            sortCriteria = 'RELEVANCE',
            pillars = [],
            documentType = 'STATE_AID',
            authorities = [],
            companies = [],
            commercialNames = [],
            subThemes = [],
            fromDecisionDate = "",
            toDecisionDate = "",
            countries = [],         
            aims = [],
            targets = [],
            outcomes = [],
            themes = [],
            types = [],
            showOpenCases=false,
        } = params;

        this.page=page;
        this.limit=limit;
        this.sortCriteria=sortCriteria;
        this.pillars =pillars;
        this.documentType=documentType;
        this.authorities=authorities;
        this.companies=companies;
        this.commercialNames=commercialNames;
        this.subThemes=subThemes;
        this.fromDecisionDate=fromDecisionDate;
        this.toDecisionDate=toDecisionDate;
        this.countries=countries;
        this.aims=aims;
        this.targets=targets;
        this.outcomes=outcomes;
        this.themes=themes;
        this.types=types;
        this.showOpenCases=showOpenCases;
        
    }
}